var _0x3319 = ['z3jVDxbfBMq=', 'y29Kzq==', 'CgfJA2fNzu5HBwu=', 'CgfYC2u=', 'lcb0AguGCgfJA2fNzsb3yxmGChvIBgLZAgvKig9Uia==', 'shjZu2W=', 'BgLJzw5ZAw5Nrg9JC1vYBa==', 'ChjVzhvJDe5HBwu=', 'zNvUy3rPB24=', 'tgLJzw5ZzsbHy3rPDMf0Aw9UigzHAwXLzcbMB3iG', 'z3jVDxa=', 'teXTvKe=', 'igzVCIbTB3jLigLUzM9YBwf0Aw9UlGO=', 'BKDMyxi=', 'ENn3DM4=', 'wMzZB1C=', 'BgvUz3rO', 'z2v0', 'DgLTzxn0yw1W', 'C2v0', 'zxHWAxj5rgf0zq==', 'uhjVz3jLC3mG', 'zhryDgu=', 'DfLTzMy=', 'B2jQzwn0', 'qNLIEK4=', 'tM8GBgLJzw5ZzsbMB3vUzc4k', 'tM9huLm=', 'quTytxO=', 'BgLJzw5Zzuv4CgLYyxrPB25eyxrL', 'ww91CIbSAwnLBNnLigv4CgLYzwqGB24G', 'CxnxEeu=', 'zMLUza==', 'svz2Cwe=', 'zg9JC1vYBa==', 'A0XhrMK=', 'r3bYz0W=', 'AgfZ', 'Dg9mB2nHBgvtDhjPBMC=', 'vgHLihbYB2r1y3qGAxmGBM90igLUy2X1zgvKigLUihrOzsbSAwnLBNnLlGO=', 'ChjVzhvJDenVzgvZ', 'u2vLia==', 'tMTLBLy=', 'A2vAA3K=', 'CuTVsMS=', 'zKfsC0K=', 'DMvYC2LVBG==', 'C2niDxq=', 'ChjVzhvJDhm=', 'DefZzLi=', 'EgXUs2y=', 'BMfTzq==', 'DenrDei=', 'ChvIBgLZAerHDgu=', 'DhLWzq==', 'zgf0yq==', 'yurcAfO=', 'D2fYBG==', 'AMHmveW='];

(function (_0x4af6af, _0x3319c8) {
  var _0x5aa72d = function _0x5aa72d(_0xc922d8) {
    while (--_0xc922d8) {
      _0x4af6af['push'](_0x4af6af['shift']());
    }
  };

  _0x5aa72d(++_0x3319c8);
})(_0x3319, 0x19f);

var _0x5aa7 = function _0x5aa7(_0x4af6af, _0x3319c8) {
  _0x4af6af = _0x4af6af - 0x0;
  var _0x5aa72d = _0x3319[_0x4af6af];

  if (_0x5aa7['Pfhzuz'] === undefined) {
    var _0xc922d8 = function _0xc922d8(_0x20c9a2) {
      var _0x4d7194 = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=',
          _0x278410 = String(_0x20c9a2)['replace'](/=+$/, '');

      var _0x2d7a35 = '';

      for (var _0x396d69 = 0x0, _0xe3f990, _0x4abe52, _0x449ec1 = 0x0; _0x4abe52 = _0x278410['charAt'](_0x449ec1++); ~_0x4abe52 && (_0xe3f990 = _0x396d69 % 0x4 ? _0xe3f990 * 0x40 + _0x4abe52 : _0x4abe52, _0x396d69++ % 0x4) ? _0x2d7a35 += String['fromCharCode'](0xff & _0xe3f990 >> (-0x2 * _0x396d69 & 0x6)) : 0x0) {
        _0x4abe52 = _0x4d7194['indexOf'](_0x4abe52);
      }

      return _0x2d7a35;
    };

    _0x5aa7['owSrkg'] = function (_0x361a84) {
      var _0x446aa3 = _0xc922d8(_0x361a84);

      var _0x841c04 = [];

      for (var _0x467b73 = 0x0, _0x123197 = _0x446aa3['length']; _0x467b73 < _0x123197; _0x467b73++) {
        _0x841c04 += '%' + ('00' + _0x446aa3['charCodeAt'](_0x467b73)['toString'](0x10))['slice'](-0x2);
      }

      return decodeURIComponent(_0x841c04);
    }, _0x5aa7['xlBApk'] = {}, _0x5aa7['Pfhzuz'] = !![];
  }

  var _0x57eaac = _0x5aa7['xlBApk'][_0x4af6af];
  return _0x57eaac === undefined ? (_0x5aa72d = _0x5aa7['owSrkg'](_0x5aa72d), _0x5aa7['xlBApk'][_0x4af6af] = _0x5aa72d) : _0x5aa72d = _0x57eaac, _0x5aa72d;
};

var context = {
  data: '  {\"timestamp\":1614970483,\"products\":[{\"trial\":false,\"code\":\"KENDOUIREACT\",\"licenseExpirationDate\":1635154143}],\"integrity\":\"QIYYmtujIFGypAojZRdQPqwIa8Y=\"}  '
},
    cache = new Map();

function validatePackage(_0x123912) {
  if (cache[_0x5aa7('0x23')](_0x123912[_0x5aa7('0x31')])) {
    if (_0x5aa7('0x29') !== _0x5aa7('0x29')) {
      var _0x12c750 = function _0x12c750() {
        message += _0x5aa7('0x25');
      };
    } else return cache[_0x5aa7('0xf')](_0x123912[_0x5aa7('0x31')]);
  }

  var _0x4cd6ab = _0x123912[_0x5aa7('0x2c')] ? '\x20v' + _0x123912[_0x5aa7('0x2c')] : '',
      _0xf0bcbb = _0x123912[_0x5aa7('0x31')] + _0x4cd6ab,
      _0x2083e8 = JSON[_0x5aa7('0x1')](context[_0x5aa7('0x35')]),
      _0x45ade6 = !_0x2083e8[_0x5aa7('0x10')],
      _0x23de50 = matchProduct(_0x2083e8, _0x123912[_0x5aa7('0x26')]),
      _0x8bb511;

  if (_0x45ade6) {
    if (_0x5aa7('0x21') === _0x5aa7('0x9')) {
      var _0xe562c4 = function _0xe562c4() {
        return null;
      };
    } else _0x8bb511 = {
      'type': 0x0,
      'packageName': _0xf0bcbb,
      'docsUrl': _0x123912[_0x5aa7('0x4')]
    };
  } else {
    if (_0x5aa7('0x14') !== _0x5aa7('0x14')) {
      var _0x1162cd = function _0x1162cd() {
        var _0x4487e4 = _0x5aa7('0x13') + _0x123912[_0x5aa7('0x5')],
            _0x23179d = typeof console[_0x5aa7('0x8')] === _0x5aa7('0x6');

        _0x23179d ? console[_0x5aa7('0x8')](_0x4487e4) : console[_0x5aa7('0x37')](_0x4487e4), console[_0x5aa7('0x37')](formatError(_0x8bb511)), _0x23179d && console[_0x5aa7('0x39')]();
      };
    } else {
      if (!_0x23de50) {
        if (_0x5aa7('0x36') !== _0x5aa7('0x1f')) _0x8bb511 = {
          'type': 0x1,
          'packageName': _0xf0bcbb,
          'docsUrl': _0x123912[_0x5aa7('0x4')]
        };else {
          var _0x221679 = function _0x221679() {
            _0x8bb511 = {
              'type': 0x1,
              'packageName': _0xf0bcbb,
              'docsUrl': _0x123912[_0x5aa7('0x4')]
            };
          };
        }
      } else {
        if (_0x5aa7('0x38') === _0x5aa7('0x22')) {
          var _0x1fd289 = function _0x1fd289() {
            var _0x833efb = _0x5aa7('0x7') + _0x8bb511[_0x5aa7('0x0')] + '\x0a';

            if (_0x8bb511[_0x5aa7('0x34')] === 0x2) _0x833efb += _0x5aa7('0x1c') + _0x8bb511[_0x5aa7('0x12')][_0x5aa7('0x24')]() + _0x5aa7('0x2') + _0x8bb511[_0x5aa7('0x33')][_0x5aa7('0x24')]() + '.\x0a';else {
              if (_0x8bb511[_0x5aa7('0x34')] === 0x0) _0x833efb += _0x5aa7('0x18');else _0x8bb511[_0x5aa7('0x34')] === 0x1 && (_0x833efb += _0x5aa7('0x25'));
            }
            return _0x833efb += _0x5aa7('0x27') + _0x8bb511[_0x5aa7('0x20')] + _0x5aa7('0xa'), _0x833efb;
          };
        } else {
          if (_0x23de50[_0x5aa7('0x1b')] < _0x123912[_0x5aa7('0x33')]) {
            if (_0x5aa7('0x17') !== _0x5aa7('0x17')) {
              var _0x245904 = function _0x245904() {
                _0x23de50[_0x5aa7('0x1b')] < _0x123912[_0x5aa7('0x33')] && (_0x8bb511 = {
                  'type': 0x2,
                  'packageName': _0xf0bcbb,
                  'publishDate': parseDate(_0x123912[_0x5aa7('0x33')]),
                  'expiryDate': parseDate(_0x23de50[_0x5aa7('0x1b')]),
                  'docsUrl': _0x123912[_0x5aa7('0x4')]
                });
              };
            } else _0x8bb511 = {
              'type': 0x2,
              'packageName': _0xf0bcbb,
              'publishDate': parseDate(_0x123912[_0x5aa7('0x33')]),
              'expiryDate': parseDate(_0x23de50[_0x5aa7('0x1b')]),
              'docsUrl': _0x123912[_0x5aa7('0x4')]
            };
          }
        }
      }
    }
  }

  if (_0x8bb511 && typeof console === _0x5aa7('0x16')) {
    if (_0x5aa7('0x28') !== _0x5aa7('0xd')) {
      var _0x3ae53a = _0x5aa7('0x13') + _0x123912[_0x5aa7('0x5')],
          _0x39d9f7 = typeof console[_0x5aa7('0x8')] === _0x5aa7('0x6');

      if (_0x39d9f7) {
        if (_0x5aa7('0x2b') !== _0x5aa7('0x2b')) {
          var _0x548f96 = function _0x548f96() {
            var _0xfdc252 = _0x2083e8[_0x5aa7('0x2e')];

            if (!_0xfdc252 || !_0xfdc252[_0x5aa7('0xe')]) return null;

            var _0x2b9257 = new Set(productCodes);

            return _0xfdc252[_0x5aa7('0x1e')](function (_0xee78d6) {
              return _0x2b9257[_0x5aa7('0x23')](_0xee78d6[_0x5aa7('0x3a')]);
            });
          };
        } else console[_0x5aa7('0x8')](_0x3ae53a);
      } else {
        if (_0x5aa7('0x3') !== _0x5aa7('0x1d')) console[_0x5aa7('0x37')](_0x3ae53a);else {
          var _0x30be4a = function _0x30be4a() {
            return packageProducts[_0x5aa7('0x23')](product[_0x5aa7('0x3a')]);
          };
        }
      }

      console[_0x5aa7('0x37')](formatError(_0x8bb511));

      if (_0x39d9f7) {
        if (_0x5aa7('0x32') !== _0x5aa7('0x32')) {
          var _0x5cb1c4 = function _0x5cb1c4() {
            message += _0x5aa7('0x1c') + _0x8bb511[_0x5aa7('0x12')][_0x5aa7('0x24')]() + _0x5aa7('0x2') + _0x8bb511[_0x5aa7('0x33')][_0x5aa7('0x24')]() + '.\x0a';
          };
        } else console[_0x5aa7('0x39')]();
      }
    } else {
      var _0x4e5118 = function _0x4e5118() {
        console[_0x5aa7('0x37')](_0x3ae53a);
      };
    }
  }

  var _0x30740a = !_0x8bb511;

  return cache[_0x5aa7('0x11')](_0x123912[_0x5aa7('0x31')], _0x30740a), _0x30740a;
}

function formatError(_0x5ab46c) {
  var _0x3d2d33 = _0x5aa7('0x7') + _0x5ab46c[_0x5aa7('0x0')] + '\x0a';

  if (_0x5ab46c[_0x5aa7('0x34')] === 0x2) {
    if (_0x5aa7('0x19') === _0x5aa7('0x1a')) {
      var _0x36eec9 = function _0x36eec9() {
        _0x5ab46c = {
          'type': 0x0,
          'packageName': packageName,
          'docsUrl': meta[_0x5aa7('0x4')]
        };
      };
    } else _0x3d2d33 += _0x5aa7('0x1c') + _0x5ab46c[_0x5aa7('0x12')][_0x5aa7('0x24')]() + _0x5aa7('0x2') + _0x5ab46c[_0x5aa7('0x33')][_0x5aa7('0x24')]() + '.\x0a';
  } else {
    if (_0x5ab46c[_0x5aa7('0x34')] === 0x0) {
      if (_0x5aa7('0xc') === _0x5aa7('0x15')) {
        var _0x4d2afe = function _0x4d2afe() {
          !licenseProduct ? _0x5ab46c = {
            'type': 0x1,
            'packageName': packageName,
            'docsUrl': meta[_0x5aa7('0x4')]
          } : licenseProduct[_0x5aa7('0x1b')] < meta[_0x5aa7('0x33')] && (_0x5ab46c = {
            'type': 0x2,
            'packageName': packageName,
            'publishDate': parseDate(meta[_0x5aa7('0x33')]),
            'expiryDate': parseDate(licenseProduct[_0x5aa7('0x1b')]),
            'docsUrl': meta[_0x5aa7('0x4')]
          });
        };
      } else _0x3d2d33 += _0x5aa7('0x18');
    } else {
      if (_0x5ab46c[_0x5aa7('0x34')] === 0x1) {
        if (_0x5aa7('0x30') === _0x5aa7('0xb')) {
          var _0x41c99a = function _0x41c99a() {
            return new Date(timestamp * 0x3e8);
          };
        } else _0x3d2d33 += _0x5aa7('0x25');
      }
    }
  }

  return _0x3d2d33 += _0x5aa7('0x27') + _0x5ab46c[_0x5aa7('0x20')] + _0x5aa7('0xa'), _0x3d2d33;
}

function matchProduct(_0x1dc901, _0x418ca) {
  var _0x141381 = _0x1dc901[_0x5aa7('0x2e')];

  if (!_0x141381 || !_0x141381[_0x5aa7('0xe')]) {
    if (_0x5aa7('0x2a') !== _0x5aa7('0x2d')) return null;else {
      var _0x1bf99f = function _0x1bf99f() {
        message += _0x5aa7('0x18');
      };
    }
  }

  var _0x273a02 = new Set(_0x418ca);

  return _0x141381[_0x5aa7('0x1e')](function (_0x352b0c) {
    if (_0x5aa7('0x2f') !== _0x5aa7('0x2f')) {
      var _0x470c57 = function _0x470c57() {
        console[_0x5aa7('0x8')](header);
      };
    } else return _0x273a02[_0x5aa7('0x23')](_0x352b0c[_0x5aa7('0x3a')]);
  });
}

function parseDate(_0x18aa65) {
  return new Date(_0x18aa65 * 0x3e8);
}

export { validatePackage };